import { Link } from '@tanstack/react-router';
import { Icon, type IconName } from '@/components/ui/icon';

const TABS: { to: string; label: string; icon: IconName; exact?: boolean }[] = [
  { to: '/', label: 'Book', icon: 'home', exact: true },
  { to: '/trips', label: 'My Trips', icon: 'trips' },
  { to: '/support', label: 'Support', icon: 'support' },
];

interface SidebarProps {
  supportBadge?: number;
  userName?: string;
  userSubtitle?: string;
  onOpenAccount: () => void;
}

/** Desktop left rail. */
export function Sidebar({ supportBadge = 0, userName, userSubtitle, onOpenAccount }: SidebarProps) {
  return (
    <aside className="wb-sidebar">
      <div className="wb-row wb-gap-10" style={{ padding: '4px 10px 20px' }}>
        <img src="/weebee-bee.png" alt="" style={{ width: 34, height: 34 }} />
        <div>
          <div
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: 19,
              letterSpacing: '-0.01em',
            }}
          >
            WayQ
          </div>
          <div className="wb-tiny" style={{ marginTop: -2 }}>
            Tickets
          </div>
        </div>
      </div>
      {TABS.map((t) => (
        <Link
          key={t.to}
          to={t.to}
          activeOptions={{ exact: t.exact }}
          className="wb-navitem"
          activeProps={{ className: 'wb-navitem is-active' }}
        >
          <Icon name={t.icon} size={22} />
          <span className="wb-grow">{t.label}</span>
          {t.to === '/support' && supportBadge > 0 && (
            <span className="wb-tab-badge" style={{ position: 'static' }}>
              {supportBadge}
            </span>
          )}
        </Link>
      ))}
      <div className="wb-grow" />
      <button type="button" className="wb-navitem" onClick={onOpenAccount}>
        <div
          className="wb-leadicon"
          style={{
            width: 30,
            height: 30,
            borderRadius: 999,
            background: 'var(--honey-wash)',
            color: 'var(--honey-700)',
          }}
        >
          <Icon name="user" size={17} />
        </div>
        <div className="wb-grow" style={{ textAlign: 'left', overflow: 'hidden' }}>
          <div
            className="wb-strong"
            style={{
              fontSize: 14,
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {userName ?? 'Account'}
          </div>
          {userSubtitle && <div className="wb-tiny wb-mono">{userSubtitle}</div>}
        </div>
      </button>
    </aside>
  );
}
